export const PERMISSIONS = {
    Admin: "caderno_LPMA.admin",
    Visitante: "caderno_LPMA.visitante",
    ReguladorRead: "caderno_LPMA.regulador.read",
    ReguladorWrite: "caderno_LPMA.regulador.write",
    RequisitanteRead: "caderno_LPMA.requisitante.read",
    RequisitanteWrite: "caderno_LPMA.requisitante.write",
    VisualizarMinhas: "caderno_LPMA.visualizar_minhas",

}

export const isAdmin = (roles: string[]): boolean => {
    const isRole = roles.filter(role => role === PERMISSIONS.Admin);

    return isRole.length ? true : false;
}
export const isCheck = (roles: string[], isPerm: string): boolean => {
    const isRole = roles.filter(role => role === isPerm);
    return isRole.length ? true : false;
}
